import { Component, inject, OnInit, ViewEncapsulation } from "@angular/core";
import { SidemeduFacadeService } from "../side-menu/sidemedu-facade.service";
import { NewSidemeduFacadeService } from "./newsidemedu-facade.service";
import { AuthService } from "../../services/auth.service";


@Component({
    selector: "app-nuevo-side",
    templateUrl: "./nuevo-side.component.html",
    styleUrls: ["./nuevo-side.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NuevoSideComponent implements OnInit {
 
  public authService = inject(AuthService);
  public usuario:any;

  constructor(public sideMenuFacade:NewSidemeduFacadeService) {
    this.sideMenuFacade.consumirMenus();
    this.obtenerInformacionLocal();
  }

  ngOnInit(): void {
    
  }

  obtenerInformacionLocal(){
    this.usuario = JSON.parse(localStorage.getItem("usuario_data") || null);
  }

  cerrarSesion(){
    this.authService.CerrarSesion();
  }
}
